import React from 'react';
import type { AgendaView } from '../types';

type TFn = (key: string, vars?: Record<string, string | number | boolean | null | undefined>, fallback?: string) => string;

interface Props {
    views: AgendaView[];
    active: AgendaView;
    onChange: (view: AgendaView) => void;
    t: TFn;
}

const META: Record<AgendaView, { icon: string; key: string; fallback: string }> = {
    grid: { icon: 'fa-th-large', key: 'agenda.view.grid', fallback: 'Cartes' },
    compact: { icon: 'fa-list', key: 'agenda.view.compact', fallback: 'Liste' },
    month: { icon: 'fa-calendar-week', key: 'agenda.view.month', fallback: 'Par mois' },
    calendar: { icon: 'fa-calendar-alt', key: 'agenda.view.calendar', fallback: 'Calendrier' },
};

/** Sélecteur de mode d'affichage de l'agenda (Lot 3). Masqué si une seule vue. */
export function AgendaViewSwitcher({ views, active, onChange, t }: Props): React.ReactElement | null {
    if (views.length <= 1) {
        return null;
    }
    return (
        <div className="gas-agenda__view-switcher" role="group" aria-label={t('agenda.view.label', {}, 'Affichage')}>
            {views.map((v) => {
                const meta = META[v];
                const isActive = v === active;
                return (
                    <button
                        key={v}
                        type="button"
                        className={`gas-agenda__view-btn${isActive ? ' gas-agenda__view-btn--active' : ''}`}
                        aria-pressed={isActive}
                        title={t(meta.key, {}, meta.fallback)}
                        onClick={() => onChange(v)}
                    >
                        <i className={`fas ${meta.icon}`} aria-hidden="true" />
                        <span className="gas-agenda__view-btn-label">{t(meta.key, {}, meta.fallback)}</span>
                    </button>
                );
            })}
        </div>
    );
}
